import { Stack, Grid2 as Grid } from '@mui/material'
import { useAccountManagement } from './hooks'
import { useParams } from 'react-router-dom'

import UserTable from './management/components/UserTable'
import { UserSchema } from '@common/config/api/client'
import AddUserMenu from './management/components/AddUserMenu'
import AssignUserModal from './management/components/AssignUserModal'
import AddUserModal from './management/components/AddUserModal'
import { SPACING } from '@common/theme/spacing'
import { SIZING } from '@common/theme/sizing'
import { useEffect } from 'react'

export default function AccountManagement() {
  const { studyId } = useParams()
  const {
    page,
    addMenuAnchor,
    isAddModalOpen,
    isAssignModalOpen,
    usersList,
    allUsersList,
    studyUsersMetadata,
    companiesMetadata,
    studyCompanySites,
    userListParams,
    isLoading,
    handleCloseUserMenu,
    handleUserTypeSelect,
    handleAddUser,
    handleAssignUser,
    handleDeleteUser,
    handleSearch,
    handlePageChange,
    handleRequestSort,
    handleRowsPerPageChange,
    setIsAddModalOpen,
    setIsAssignModalOpen,
    handleUserTypeChange,
  } = useAccountManagement(studyId!)

  useEffect(() => {
    handleUserTypeChange()
  }, [location.hash, studyUsersMetadata?.user_types, handleUserTypeChange])

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <Grid container columnSpacing={SPACING.spacingXl} sx={{ marginTop: SPACING.spacingXxl }}>
      <Grid size={SIZING.gridSizeXxl}>
        <Stack spacing={SPACING.spacing2xl}>
          <UserTable
            studyUsersMetadata={studyUsersMetadata}
            usersList={usersList}
            studyCompanySites={studyCompanySites}
            onUserTypeSelect={handleUserTypeSelect}
            onDeleteUser={handleDeleteUser}
            page={page}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onSearch={handleSearch}
            onRequestSort={handleRequestSort}
            searchValue={userListParams.search ?? ''}
            orderBy={userListParams.order_by_field as keyof UserSchema}
            order={userListParams.asc_order ? 'asc' : 'desc'}
          />
        </Stack>
      </Grid>
      <AddUserMenu anchorEl={addMenuAnchor} onClose={handleCloseUserMenu} onUserTypeSelect={handleUserTypeSelect} />
      <AddUserModal
        open={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSubmit={handleAddUser}
        companiesMetadata={companiesMetadata}
        studyCompanySites={studyCompanySites}
      />
      <AssignUserModal
        open={isAssignModalOpen}
        onClose={() => setIsAssignModalOpen(false)}
        onSubmit={handleAssignUser}
        companiesMetadata={companiesMetadata}
        studyCompanySites={studyCompanySites}
        allUsersList={allUsersList}
        studyUsersList={usersList}
      />
    </Grid>
  )
}
